import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Card,
  Container,
  Row,
  Col,
  Form,
  Button,
  Table,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import SideMenu from "../../UI/SIdeMenu";
import Navibar from "../../UI/Navibar";
import {
  updateDepStaDetailsReport,
  postDepStaDetailsReport,
  postDepStaDetailsExcel,
  resetDepStaDetailsReport,
} from "./DepStaDetailsSlice";
import { triggerBase64Download } from "common-base64-downloader-react";
import Footer from "../../UI/Footer";

function DepStaDetailsComponent() {
  const dispatch = useDispatch();
  const { depStaDetailsReport } = useSelector(
    (state) => state.DepStaDetailsSlice
  );
  const [table, setTable] = useState([]);
  const { yearMonth } = depStaDetailsReport;
  const [total, setTotal] = useState({
    noOfPaxStateTotal: 0,
    d1StateTotal: 0,
    d2StateTotal: 0,
    d3StateTotal: 0,
    d4StateTotal: 0,
    d5StateTotal: 0,
    d6StateTotal: 0,
    d7StateTotal: 0,
    d8StateTotal: 0,
    d9StateTotal: 0,
    d10StateTotal: 0,
    d11StateTotal: 0,
    d12StateTotal: 0,
    d13StateTotal: 0,
    d14StateTotal: 0,
    d15StateTotal: 0,
    d16StateTotal: 0,
    d17StateTotal: 0,
    d18StateTotal: 0,
    d19StateTotal: 0,
    d20StateTotal: 0,
    d21StateTotal: 0,
    d22StateTotal: 0,
    d23StateTotal: 0,
    d24StateTotal: 0,
    d25StateTotal: 0,
    d26StateTotal: 0,
    d27StateTotal: 0,
    d28StateTotal: 0,
    d29StateTotal: 0,
    d30StateTotal: 0,
    d31StateTotal: 0,
  });

  const handleChangeForm = (e) => {
    // "2023-07"

    const currVal = e.target.value;
    const [year, month] = currVal.split("-");

    const entity = { ...depStaDetailsReport, yearMonth: currVal, year, month };
    dispatch(updateDepStaDetailsReport(entity));
  };

  const handleClickSearch = () => {
    const entity = { ...depStaDetailsReport };
    // console.log(entity);
    dispatch(postDepStaDetailsReport(entity)).then((res) => {
      // console.log(res);
      // console.log(res.payload);
      let totalResNoOfPax = 0;
      let totalResd1 = 0;
      let totalResd2 = 0;
      let totalResd3 = 0;
      let totalResd4 = 0;
      let totalResd5 = 0;
      let totalResd6 = 0;
      let totalResd7 = 0;
      let totalResd8 = 0;
      let totalResd9 = 0;
      let totalResd10 = 0;
      let totalResd11 = 0;
      let totalResd12 = 0;
      let totalResd13 = 0;
      let totalResd14 = 0;
      let totalResd15 = 0;
      let totalResd16 = 0;
      let totalResd17 = 0;
      let totalResd18 = 0;
      let totalResd19 = 0;
      let totalResd20 = 0;
      let totalResd21 = 0;
      let totalResd22 = 0;
      let totalResd23 = 0;
      let totalResd24 = 0;
      let totalResd25 = 0;
      let totalResd26 = 0;
      let totalResd27 = 0;
      let totalResd28 = 0;
      let totalResd29 = 0;
      let totalResd30 = 0;
      let totalResd31 = 0;
      res.payload.forEach((res) => {
        console.log(res);
        totalResNoOfPax += +res.total_staff;
        // console.log(totalResNoOfPax);
        totalResd1 += +res.d1;
        // console.log(totalResd1);
        totalResd2 += +res.d2;
        totalResd3 += +res.d3;
        totalResd4 += +res.d4;
        totalResd5 += +res.d5;
        totalResd6 += +res.d6;
        totalResd7 += +res.d7;
        totalResd8 += +res.d8;
        totalResd9 += +res.d9;
        totalResd10 += +res.d10;
        totalResd11 += +res.d11;
        totalResd12 += +res.d12;
        totalResd13 += +res.d13;
        totalResd14 += +res.d14;
        totalResd15 += +res.d15;
        totalResd16 += +res.d16;
        totalResd17 += +res.d17;
        totalResd18 += +res.d18;
        totalResd19 += +res.d19;
        totalResd20 += +res.d20;
        totalResd21 += +res.d21;
        totalResd22 += +res.d22;
        totalResd23 += +res.d23;
        totalResd24 += +res.d24;
        totalResd25 += +res.d25;
        totalResd26 += +res.d26;
        totalResd27 += +res.d27;
        totalResd28 += +res.d28;
        totalResd29 += +res.d29;
        totalResd30 += +res.d30;
        totalResd31 += +res.d31;
      });
      setTotal({
        noOfPaxStateTotal: totalResNoOfPax,
        d1StateTotal: totalResd1,
        d2StateTotal: totalResd2,
        d3StateTotal: totalResd3,
        d4StateTotal: totalResd4,
        d5StateTotal: totalResd5,
        d6StateTotal: totalResd6,
        d7StateTotal: totalResd7,
        d8StateTotal: totalResd8,
        d9StateTotal: totalResd9,
        d10StateTotal: totalResd10,
        d11StateTotal: totalResd11,
        d12StateTotal: totalResd12,
        d13StateTotal: totalResd13,
        d14StateTotal: totalResd14,
        d15StateTotal: totalResd15,
        d16StateTotal: totalResd16,
        d17StateTotal: totalResd17,
        d18StateTotal: totalResd18,
        d19StateTotal: totalResd19,
        d20StateTotal: totalResd20,
        d21StateTotal: totalResd21,
        d22StateTotal: totalResd22,
        d23StateTotal: totalResd23,
        d24StateTotal: totalResd24,
        d25StateTotal: totalResd25,
        d26StateTotal: totalResd26,
        d27StateTotal: totalResd27,
        d28StateTotal: totalResd28,
        d29StateTotal: totalResd29,
        d30StateTotal: totalResd30,
        d31StateTotal: totalResd31,
      });
      setTable(res.payload);
    });
  };

  const handleExportExcel = () => {
    const entity = { ...depStaDetailsReport };
    dispatch(postDepStaDetailsExcel(entity)).then((res) => {
      console.log(res);
      console.log(res.payload);
      const base64EXCEL =
        "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
        res.payload;
      triggerBase64Download(
        base64EXCEL,
        "departmentdetails_report" + "_" + new Date().toISOString().slice(0, 10)
      );
    });
  };

  const handleBack = () => {
    const entity = { ...depStaDetailsReport };
    dispatch(resetDepStaDetailsReport(entity));
    setTable([]);
    setTotal({
      noOfPaxStateTotal: 0,
      d1StateTotal: 0,
      d2StateTotal: 0,
      d3StateTotal: 0,
      d4StateTotal: 0,
      d5StateTotal: 0,
      d6StateTotal: 0,
      d7StateTotal: 0,
      d8StateTotal: 0,
      d9StateTotal: 0,
      d10StateTotal: 0,
      d11StateTotal: 0,
      d12StateTotal: 0,
      d13StateTotal: 0,
      d14StateTotal: 0,
      d15StateTotal: 0,
      d16StateTotal: 0,
      d17StateTotal: 0,
      d18StateTotal: 0,
      d19StateTotal: 0,
      d20StateTotal: 0,
      d21StateTotal: 0,
      d22StateTotal: 0,
      d23StateTotal: 0,
      d24StateTotal: 0,
      d25StateTotal: 0,
      d26StateTotal: 0,
      d27StateTotal: 0,
      d28StateTotal: 0,
      d29StateTotal: 0,
      d30StateTotal: 0,
      d31StateTotal: 0,
    });
  };
  return (
    <div className="Div">
      <Container fluid>
      <Row>
          <Col xs={12} className="fixed-top">
            <Navibar />
          </Col>
        </Row>
        <Row>
          <Col xs={2} id="sidebar-wrapper" className="sidemenu"  style={{ marginTop: "50px" }}>
            <SideMenu />
          </Col>
          <Col>
            <Card className="content">
              <Form>
                <Container>
                  <Row className="mb-3 mt-3">
                    <Col md={12}>
                      <h4>DEPARTMENT STATISTICS-DETAILS</h4>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={3}>
                      <Form.Label>FROM DATE:</Form.Label>
                    </Col>
                    <Col md={9}>
                      <Form.Control
                        type="month"
                        value={yearMonth}
                        onChange={handleChangeForm}
                        placeholder="----,--"
                      ></Form.Control>
                    </Col>
                  </Row>
                  <Row className="justify-content-md-center mb-3">
                    <Col xs="auto" md={12}>
                      <Form.Group>
                        <Button
                          type="button"
                          bg="dark"
                          variant="dark"
                          onClick={handleClickSearch}
                        >
                          SEARCH
                        </Button>
                      </Form.Group>
                    </Col>
                  </Row>{" "}
                  <Card>
                    <Table striped bordered hover size="sm" responsive>
                      <thead>
                        <tr>
                          <th>DEPARTMENT</th>
                          <th>NO.OF PAX</th>
                          <th>1</th>
                          <th>2</th>
                          <th>3</th>
                          <th>4</th>
                          <th>5</th>
                          <th>6</th>
                          <th>7</th>
                          <th>8</th>
                          <th>9</th>
                          <th>10</th>
                          <th>11</th>
                          <th>12</th>
                          <th>13</th>
                          <th>14</th>
                          <th>15</th>
                          <th>16</th>
                          <th>17</th>
                          <th>18</th>
                          <th>19</th>
                          <th>20</th>
                          <th>21</th>
                          <th>22</th>
                          <th>23</th>
                          <th>24</th>
                          <th>25</th>
                          <th>26</th>
                          <th>27</th>
                          <th>28</th>
                          <th>29</th>
                          <th>30</th>
                          <th>31</th>
                        </tr>
                      </thead>
                      <tbody>
                        {table.map(
                          (
                            {
                              total_staff,
                              description,
                              d1,
                              d2,
                              d3,
                              d4,
                              d5,
                              d6,
                              d7,
                              d8,
                              d9,
                              d10,
                              d11,
                              d12,
                              d13,
                              d14,
                              d15,
                              d16,
                              d17,
                              d18,
                              d19,
                              d20,
                              d21,
                              d22,
                              d23,
                              d24,
                              d25,
                              d26,
                              d27,
                              d28,
                              d29,
                              d30,
                              d31,
                            },
                            i
                          ) => (
                            <tr key={i}>
                              <td>{description}</td>
                              <td>{total_staff}</td>
                              <td>{d1}</td>
                              <td>{d2}</td>
                              <td>{d3}</td>
                              <td>{d4}</td>
                              <td>{d5}</td>
                              <td>{d6}</td>
                              <td>{d7}</td>
                              <td>{d8}</td>
                              <td>{d9}</td>
                              <td>{d10}</td>
                              <td>{d11}</td>
                              <td>{d12}</td>
                              <td>{d13}</td>
                              <td>{d14}</td>
                              <td>{d15}</td>
                              <td>{d16}</td>
                              <td>{d17}</td>
                              <td>{d18}</td>
                              <td>{d19}</td>
                              <td>{d20}</td>
                              <td>{d21}</td>
                              <td>{d22}</td>
                              <td>{d23}</td>
                              <td>{d24}</td>
                              <td>{d25}</td>
                              <td>{d26}</td>
                              <td>{d27}</td>
                              <td>{d28}</td>
                              <td>{d29}</td>
                              <td>{d30}</td>
                              <td>{d31}</td>
                            </tr>
                          )
                        )}
                        <tr style={{ fontWeight: "bold" }}>
                          <td>TOTAL</td>
                          <td>{parseFloat(total?.noOfPaxStateTotal)}</td>
                          <td>{parseFloat(total?.d1StateTotal)}</td>
                          <td>{parseFloat(total?.d2StateTotal)}</td>
                          <td>{parseFloat(total?.d3StateTotal)}</td>
                          <td>{parseFloat(total?.d4StateTotal)}</td>
                          <td>{parseFloat(total?.d5StateTotal)}</td>
                          <td>{parseFloat(total?.d6StateTotal)}</td>
                          <td>{parseFloat(total?.d7StateTotal)}</td>
                          <td>{parseFloat(total?.d8StateTotal)}</td>
                          <td>{parseFloat(total?.d9StateTotal)}</td>
                          <td>{parseFloat(total?.d10StateTotal)}</td>
                          <td>{parseFloat(total?.d11StateTotal)}</td>
                          <td>{parseFloat(total?.d12StateTotal)}</td>
                          <td>{parseFloat(total?.d13StateTotal)}</td>
                          <td>{parseFloat(total?.d14StateTotal)}</td>
                          <td>{parseFloat(total?.d15StateTotal)}</td>
                          <td>{parseFloat(total?.d16StateTotal)}</td>
                          <td>{parseFloat(total?.d17StateTotal)}</td>
                          <td>{parseFloat(total?.d18StateTotal)}</td>
                          <td>{parseFloat(total?.d19StateTotal)}</td>
                          <td>{parseFloat(total?.d20StateTotal)}</td>
                          <td>{parseFloat(total?.d21StateTotal)}</td>
                          <td>{parseFloat(total?.d22StateTotal)}</td>
                          <td>{parseFloat(total?.d23StateTotal)}</td>
                          <td>{parseFloat(total?.d24StateTotal)}</td>
                          <td>{parseFloat(total?.d25StateTotal)}</td>
                          <td>{parseFloat(total?.d26StateTotal)}</td>
                          <td>{parseFloat(total?.d27StateTotal)}</td>
                          <td>{parseFloat(total?.d28StateTotal)}</td>
                          <td>{parseFloat(total?.d29StateTotal)}</td>
                          <td>{parseFloat(total?.d30StateTotal)}</td>
                          <td>{parseFloat(total?.d31StateTotal)}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </Card>
                  <Row className="mb-3 mt-3"> 
                    <Col>
                      <Button
                        type="button"
                        bg="dark"
                        variant="dark"
                        onClick={handleBack}
                      >
                        Back
                      </Button>
                    </Col>
                    <Col md={9}></Col>
                    <Col md={2}>
                      <Button
                        type="button"
                        bg="dark"
                        variant="dark"
                        onClick={() => handleExportExcel()}
                      >
                        Export Excel Report
                      </Button>
                    </Col>
                  </Row>
                </Container>
              </Form>
            </Card>
          </Col>
        </Row>
      </Container>

      <Footer />
    </div>
  );
}

export default DepStaDetailsComponent;
